import React from 'react';

const Dashboard = () => (
  <div className="py-3">Please Select A Report Using The Menu On The Left.</div>
);

export default Dashboard;
